import { useState, useEffect } from 'react';
import { X } from 'lucide-react';

const WeTravelModal = ({ 
  isOpen, 
  onClose, 
  url,
  loadingTitle = 'Préparation de votre espace…',
  loadingSubtitle = 'Réservation sécurisée',
  closeLabel = 'Fermer'
}) => {
  const [loading, setLoading] = useState(true);
  const [showIframe, setShowIframe] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setLoading(true);
      setShowIframe(false);
      const timer = setTimeout(() => setShowIframe(true), 1500);
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <>
      {/* Styles */}
      <style>{`
        .wetravel-modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(63, 42, 36, 0.95);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 10000;
          animation: wtFadeIn 0.3s ease;
        }
        .wetravel-modal-content {
          position: relative;
          width: 90%;
          max-width: 900px;
          height: 85vh;
          background: #F5F0E8;
          border-radius: 16px;
          overflow: hidden;
          animation: wtSlideUp 0.4s ease;
        }
        .wetravel-modal-close {
          position: absolute;
          top: 12px;
          right: 12px;
          width: 36px;
          height: 36px;
          border-radius: 50%;
          background: #3F2A24;
          color: #F3E5CF;
          border: none;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 18px;
          z-index: 10002;
          transition: all 0.2s ease;
        }
        .wetravel-modal-close:hover {
          background: #C5A059;
          transform: scale(1.1);
        }
        .wetravel-modal-iframe {
          width: 100%;
          height: 100%;
          border: none;
        }
        @keyframes wtFadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes wtSlideUp {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes wtPulse {
          0%, 100% { opacity: 0.4; width: 40px; }
          50% { opacity: 1; width: 80px; }
        }
      `}</style>

      <div 
        className="wetravel-modal-overlay"
        onClick={(e) => {
          if (e.target === e.currentTarget) onClose();
        }}
      >
        {/* Loading Message */}
        {loading && (
          <div style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            textAlign: 'center',
            color: '#F3E5CF',
            zIndex: 10001
          }}>
            <div style={{
              fontFamily: "'Cormorant Garamond', serif",
              fontSize: '28px',
              fontWeight: 500,
              letterSpacing: '0.1em',
              marginBottom: '20px'
            }}>{loadingTitle}</div>
            <div style={{
              width: '60px',
              height: '2px',
              background: '#C5A059',
              margin: '0 auto',
              animation: 'wtPulse 1.5s ease-in-out infinite'
            }}></div>
            <div style={{
              fontSize: '14px',
              color: '#C5A059',
              letterSpacing: '0.15em',
              textTransform: 'uppercase',
              marginTop: '20px'
            }}>{loadingSubtitle}</div>
          </div>
        )}

        {/* Modal Content */}
        {showIframe && (
          <div className="wetravel-modal-content">
            <button 
              className="wetravel-modal-close"
              onClick={onClose}
              aria-label={closeLabel}
            >
              <X className="w-5 h-5" />
            </button>
            <iframe
              src={url}
              className="wetravel-modal-iframe"
              title="WeTravel Booking"
              onLoad={() => setLoading(false)}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default WeTravelModal;
